import { AccountActStatus } from '@nf/utils-common/constants';
import type { AppbarItemProps } from '../appbar-item.types';
import { useUnsettledStatusCountInfo } from '@/hooks/query';
import { useAccountStatus } from '@/hooks/query/account';

import { AppbarItem } from '../appbar-item';

export const AppbarItemWithTicketCount = (restProps: AppbarItemProps) => {
	const { data: actStatus } = useAccountStatus();
	const { statusCount } = useUnsettledStatusCountInfo(actStatus === AccountActStatus.Deposited ? 1 : 0); // auto use 1
		
	return (
		<AppbarItem 
			{...restProps}
			statusCount={statusCount?.WC}
		/>
	);
};